import firebase from '../../fbConfig';
import { v4 as uuid } from 'uuid';

import { setAlert } from './alertAction';
import {
  BOOK_ERROR,
  ADD_BOOK,
  UPDATE_BOOK,
  DELETE_BOOK,
  ADD_GUEST_ENTRY,
} from './actionTypes';

const storage = firebase.storage();

export const addNewBook = (formData, image) => async (
  dispatch,
  getState,
  { getFirebase, getFirestore }
) => {
  const firestore = getFirestore();

  try {
    const storageRef = storage.ref('images');
    const fileRef = storageRef.child(image.name);
    await fileRef.put(image);
    await firestore.collection('books').add({
      title: formData.title,
      description: formData.description,
      reading: formData.reading,
      pages: formData.pages,
      amazone: formData.amazone,
      guestbook: [],
      imageName: image.name,
      imageURL: await fileRef.getDownloadURL(),
      pricePocketBook: formData.pricePocketBook,
      priceHardBack: formData.priceHardBack,
      priceEbook: formData.priceEbook,
      createdAt: new Date(),
    });
    dispatch({ type: ADD_BOOK, formData });

    dispatch(setAlert('Buch erfolgreich hochgeladen.', 'success'));
  } catch (err) {
    dispatch({ type: BOOK_ERROR, err });
  }
};

export const updateBook = (formData, id) => async (
  dispatch,
  getState,
  { getFirebase, getFirestore }
) => {
  const firestore = getFirestore();
  try {
    await firestore.collection('books').doc(id).update({
      title: formData.title,
      description: formData.description,
      reading: formData.reading,
      pages: formData.pages,
      amazone: formData.amazone,
      imageName: formData.imageName,
      imageURL: formData.imageURL,
      pricePocketBook: formData.pricePocketBook,
      priceHardBack: formData.priceHardBack,
      priceEbook: formData.priceEbook,
      createdAt: formData.createdAt,
    });
    dispatch({ type: UPDATE_BOOK, formData });

    dispatch(setAlert('Buch erfolgreich editiert.', 'success'));
  } catch (err) {
    dispatch({ type: BOOK_ERROR, err });
  }
};

export const deleteBook = (imageName, id) => async (
  dispatch,
  getState,
  { getFirebase, getFirestore }
) => {
  if (window.confirm('Are you sure? This can NOT be undone!')) {
    const firestore = getFirestore();

    try {
      const storageRef = storage.ref('images').child(`${imageName}`);
      await storageRef.delete();

      await firestore.collection('books').doc(id).delete();

      dispatch({ type: DELETE_BOOK });

      dispatch(setAlert('Buch erfolgreich gelöscht.', 'success'));
    } catch (err) {
      dispatch({ type: BOOK_ERROR, err });
    }
  }
};

export const addGuestEntry = (id, formData) => async (
  dispatch,
  getState,
  { getFirebase, getFirestore }
) => {
  const firestore = getFirestore();

  try {
    const bookRef = await firestore.collection('books').doc(id);
    await bookRef.update({
      guestbook: firestore.FieldValue.arrayUnion({
        id: uuid(),
        author: formData.author,
        email: formData.email,
        text: formData.text,
        createdAt: new Date().toISOString(),
      }),
    });
    dispatch({ type: ADD_GUEST_ENTRY });
  } catch (err) {
    dispatch({ type: BOOK_ERROR, err });
  }
};
